import React from 'react';
import { AwarenessTemplate } from '../components/training/templates/AwarenessTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getAwarenessContent } from '../data/standards/trainingContent';

export const ISO50001Awareness = () => {
  const standard = getStandardBySlug('iso-50001');
  const content = getAwarenessContent('iso-50001');

  return <AwarenessTemplate standard={standard} content={content} />;
};
